<template>
  <v-dialog
    v-model="visible"
    persistent
    max-width="500"
  >
    <global-card
      :title
      closable
      @close="visible = false"
    >
      <v-text-field
        ref="inputField"
        v-model="inputValue"
        :label="title"
        autofocus
        :rules
        :required
        @keyup.enter="onOk"
      />
      <slot />
      <template #actions>
        <v-btn
          color="dark-grey"
          size="default"
          @click="onCancel"
        >
          {{ $t('actions.cancel') }}
        </v-btn>
        <v-btn
          color="primary"
          size="default"
          @click="onOk"
        >
          {{ $t('actions.save') }}
        </v-btn>
      </template>
    </global-card>
  </v-dialog>
</template>

<script setup lang="ts">
import type { VTextField } from 'vuetify/components';
import { computed, ref, watch } from 'vue';
import { useI18n } from 'vue-i18n';

const props = defineProps<{
  modelValue: boolean;
  title?: string;
  initialValue?: string | number;
  required?: boolean;
}>();

const emit = defineEmits<{
  (_e: 'update:modelValue', _value: boolean): void;
  (_e: 'close', _value: string | number | null): void;
}>();

const { t } = useI18n();
const visible = ref(props.modelValue);
const inputField = ref<VTextField | null>(null);
const inputValue = ref(props.initialValue ?? '');

const rules = computed(() => {
  return props.required
    ? [
        (value: unknown) => !!value || t('validation.required_value'),
      ]
    : undefined;
});

watch(() => props.modelValue, val => {
  visible.value = val;
});

watch(visible, val => {
  emit('update:modelValue', val);
});

watch(
  () => props.initialValue,
  (val) => {
    inputValue.value = val ?? '';
  },
);

function onOk() {
  if (!inputField.value?.validity.valid) {
    return;
  }
  emit('close', inputValue.value);
  visible.value = false;
}

function onCancel() {
  visible.value = false;
}
</script>
